import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbDateDEParserFormatter extends NgbDateParserFormatter {
  public parse(value: string): NgbDateStruct {
    let ret = null;
    if (value) {
      const dateParts = value.trim().split('.');
      if (dateParts.length === 1 && this.#isNumber(dateParts[0]) && this.yearLengthValid(dateParts[0])) {
        ret = { year: this.#toInteger(dateParts[0]), month: null, day: null };
      } else if (
        dateParts.length === 2 &&
        this.#isNumber(dateParts[0]) &&
        this.#isNumber(dateParts[1]) &&
        this.yearLengthValid(dateParts[1])
      ) {
        ret = {
          year: this.#toInteger(dateParts[1]),
          month: this.#toInteger(dateParts[0]),
          day: null,
        };
      } else if (
        dateParts.length === 3 &&
        this.#isNumber(dateParts[0]) &&
        this.#isNumber(dateParts[1]) &&
        this.#isNumber(dateParts[2]) &&
        this.yearLengthValid(dateParts[2])
      ) {
        ret = {
          year: this.#toInteger(dateParts[2]),
          month: this.#toInteger(dateParts[1]),
          day: this.#toInteger(dateParts[0]),
        };
      }
    }
    if (ret?.month > 12) {
      ret = null;
    }
    return ret;
  }

  public yearLengthValid(year: string): boolean {
    return year.length === 4;
  }

  public format(date: NgbDateStruct): string {
    return date
      ? [
          this.#isNumber(date.day) ? this.#padNumber(date.day) : '',
          this.#isNumber(date.month) ? this.#padNumber(date.month) : '',
          date.year,
        ]
          .filter(Boolean)
          .join('.')
      : '';
  }

  #padNumber = (value: number) => (this.#isNumber(value) ? `0${value}`.slice(-2) : '');
  #isNumber = (value: string | number): boolean => !isNaN(this.#toInteger(value));
  #toInteger = (value: string | number): number => parseInt(`${value}`, 10);
}
